import React from "react";
import { getBrackets } from '../../utilities/js/callouts/CalloutFactory';

import Constants from "../../utilities/js/Constants";
import "./BracketListItem.css";
import getTimeSince from "utilities/js/TimeManager";
import { navigateToCreate } from "utilities/js/NavigationHelper";
import { navigateToView } from "utilities/js/NavigationHelper";
import { navigateToAccountPage } from "utilities/js/NavigationHelper";
import { NavigatorWrapper } from "./NavigatorWrapper";

const openNewTabIcon = Constants.ICON_NEW_TAB;
const editIcon = Constants.ICON_EDIT;

class BracketListItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bracket: this.props.bracket
        };

        this.navigateToView = this.navigateToView.bind(this);
        this.navigateToEdit = this.navigateToEdit.bind(this);
        this.navigateToAccount = this.navigateToAccount.bind(this);
    }

    componentDidMount() {

    }

    
    get lastUpdated(){
        return getTimeSince(this.state.bracket.updated_date);//.split('T')[0];
    }

    get creator(){
        return this.state.bracket.created_by.username;
    }

    get creatorColor(){
        return this.state.bracket.created_by.color;
    }

    navigateToView(event){
        navigateToView({
            bracketId: this.state.bracket.view_id,
            routerNav: this.props.navigate
        });
    }

    navigateToEdit(event){
        navigateToCreate({
            bracketId: this.state.bracket.bracket_id,
            routerNav: this.props.navigate
        });
    }

    navigateToAccount(event){
        navigateToAccountPage({
            accountId: this.state.bracket.created_by._id, 
            routerNav: this.props.navigate
        });
    }

    getEditBracketIcon(bracket){
        if(bracket.editable){
            return (
                <div className="bracket-list-nav-buttons">
                    <img className="bracket-list-edit-icon" alt="edit" src={editIcon} data-name={bracket._id} onClick={this.navigateToEdit}></img>
                    {/* <img className="bracket-list-new-tab-icon" alt="open-new-tab" src={openNewTabIcon}  data-name={bracket._id} onClick={this.navigateToView}></img> */}
                </div>
            );
        }
        return (<></>)
    }

    get bracketListItemDisplay(){

        let bracket = this.state.bracket;
        let editBracketIcon = this.getEditBracketIcon(bracket);

        if(this.props.variant === 'side-panel'){

            return (
                <div key={bracket._id} className="bracket-list-item">
                    <div className="list-item-text">
                        <div className="list-item-label" onClick={this.navigateToView} data-name={bracket._id}>{bracket.title}</div>
                        <div className="list-item-subtext">{this.lastUpdated}</div>
                    </div>
                    {editBracketIcon}
                </div>
            )

        }else if(this.props.variant === 'feed' || this.props.variant === 'detail'){

            return (
                <div key={bracket._id} className="bracket-list-item">
                    
                    <div className="list-item-text list-item-feed">
                        <div className="list-item-icon">
                            <div className="account-icon-indicator" style={{backgroundColor: this.creatorColor}}>{this.creator.substring(0,1)}</div>
                        </div>
                        <div className="list-item-card">
                            <div className="list-item-creator" onClick={this.navigateToAccount} >{this.creator}</div>
                            <div className="list-item-label" onClick={this.navigateToView} data-name={bracket._id}>{bracket.title}</div>
                            <div className="list-item-subtext">{this.lastUpdated}</div>
                        </div>
                        
                    </div>
                    {editBracketIcon}
                </div>
            )

        }else{

            return (
                <div key={bracket._id} className="bracket-list-item">
                    <div className="list-item-text">
                        <div className="list-item-label" onClick={this.navigateToView} data-name={bracket._id}>{bracket.title}</div>
                        <div className="list-item-subtext">{this.lastUpdated}</div>
                    </div>
                    {editBracketIcon}
                </div>
            )
        }
    }
    
    render(){
        return this.bracketListItemDisplay;
    }

}


export default NavigatorWrapper(BracketListItem);